import { ConfigurableItem, GetPdfConfigsArgs } from './types';

const getPdfConfigs = <T extends ConfigurableItem>({
  items,
  target,
  urlBuilder,
  filterPredicate,
}: GetPdfConfigsArgs<T>) => {
  if (!items) {
    return [];
  }

  const filteredItems = filterPredicate ? items.filter(filterPredicate) : items;

  return filteredItems.map(item => ({
    urlBuilder,
    target: {
      ...target,
      // If the item has a specific name (like a specific Valuation Approach), 
      // we override the generic category title so it ends up in each page
      // instead of just the approach name or a generic title.
      title: item.name ?? target.title,
    },
  }));
};

export default getPdfConfigs;
